import React from 'react'
import {css} from '@emotion/core'
import HamburgerLink from './HamburgerLink'

const HamburgerSection = ({sectionTitle, linkData, theme, themeStyles, lang, setShowMenu}) => {
    return (
        <div
            css={css`
                padding-bottom: 32px;
                &:not(:first-of-type) {
                    margin-top: 32px;
                }
                &:not(:last-of-type) {
                    border-bottom: 1px solid ${themeStyles.borderColor};
                }
            `}
        >
            <h4
                css={css`
                    font-size: 12px;
                    font-weight: 700;
                    text-transform: uppercase;
                    color: ${themeStyles.quintaryTextColor};
                    letter-spacing: 0.24px;
                    line-height: 30px;
                    margin-bottom: 32px;
                `}
            >
                {sectionTitle}
            </h4>
            <div
                css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 32px;
                `}
            >
                {linkData?.map((linkDatum, i) => {
                    return (
                        <HamburgerLink
                            key={i}
                            linkData={linkDatum}
                            theme={theme}
                            themeStyles={themeStyles}
                            lang={lang}
                            setShowMenu={setShowMenu}
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default HamburgerSection
